export function androidCertificateValidation(content) {
  const fields = [
    "type",
    "project_id",
    "private_key_id",
    "private_key",
    "client_email",
    "client_id",
    "auth_uri",
    "token_uri",
    "auth_provider_x509_cert_url",
    "client_x509_cert_url",
  ]

  const certificateObject = JSON.parse(content)

  return fields.every(field => Object.keys(certificateObject).includes(field))
}

export function iosCertificateValidation(content) {
  const regex = /^-----BEGIN PRIVATE KEY-----\r?\n([A-Za-z0-9+/=\r\n]+)-----END PRIVATE KEY-----\r?\n?$/

  return content.match(regex)
}

export function appVersionValidation(version) {
  const regex = /^\d+\.\d+\.\d+$/

  return version.match(regex)
}

export function urlSchemeValidation(scheme) {
  const regex = /^[a-z0-9]+$/

  return regex.test(scheme)
}
